module.exports = __webpack_public_path__ + "img/实时监测和报告.8e7f0a0c.png";